export default "__VITE_ASSET__CAyGN_Rp__"